export default __webpack_public_path__ + "static/media/sports_esports.b823edf4.svg";